import { func, object, arrayOf, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { hasDiaryBeenFilled, timeLeft } from 'routes/Documents/routes/OnlineRehabilitation/utils';

import appStoreLogo from './Download_on_the_App_Store_Badge_FI_RGB_blk_100217.svg';

import ContentColumns from '../../components/ContentColumns';

const PlayStoreBadge = () => (
  <div>
    <a
      target="_blank"
      rel="noreferrer"
      href="https://play.google.com/store/apps/details?id=com.mystellarqmobile&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    >
      <img
        style={{ width: '15rem' }}
        alt="Get it on Google Play"
        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
      />
    </a>
  </div>
);

const AppStoreBadge = () => (
  <div>
    <a target="_blank" rel="noreferrer" href="https://apps.apple.com/fi/app/stellarq-my/id1659625985">
      <img style={{ width: '15rem', padding: '1rem' }} alt="App store" src={appStoreLogo} />
    </a>
  </div>
);

const View2 = ({ documents }, { fm, formValues, editingDocumentId }) => {
  const finished = path(['rehab2', 'finished'], formValues);
  const thisRehab = documents.find(d => d.documentId === editingDocumentId);
  const diaryFilled = hasDiaryBeenFilled(documents, path(['createDate'], thisRehab));
  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab2.2.header')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab2.2.text')}</div>
            <br />
            <div>{fm('onlineRehabilitation.rehab2.2.instructionsPlayStore')}</div>
            <PlayStoreBadge />
            <br />
            <div>{fm('onlineRehabilitation.rehab2.2.instructionsAppStore')}</div>
            <AppStoreBadge />
            <br />
            <div>{fm('onlineRehabilitation.rehab2.2.text2')}</div>
            <br />
            <div>{fm('onlineRehabilitation.rehab2.2.text3')}</div>
            <br />
            {finished && (
              <span>
                {fm('onlineRehabilitation.nextRehab')}{' '}
                {diaryFilled ? timeLeft(finished) : fm('onlineRehabilitation.diaryFilled')}
              </span>
            )}
          </div>
        }
      />
    </React.Fragment>
  );
};

View2.contextTypes = {
  fm: func,
  formValues: object,
  editingDocumentId: string,
};
View2.propTypes = {
  documents: arrayOf(object),
};

export default View2;
